import { useEffect, useState } from "react";
import { Timer } from "@phosphor-icons/react";

function parseAuctionDate(iso, raw) {
    if (iso && /^\d{4}-\d{2}-\d{2}$/.test(iso)) {
        const [y, m, d] = iso.split("-").map(Number);
        return new Date(y, m - 1, d);
    }
    if (raw) {
        const m = String(raw).match(/(\d{1,2})[/.](\d{1,2})[/.](\d{4})/);
        if (m) return new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
    }
    return null;
}

// Termine tipico: ore 12:00 del giorno precedente l'asta (da verificare sull'avviso)
export function computeOfferDeadline(iso, raw) {
    const d = parseAuctionDate(iso, raw);
    if (!d) return null;
    const deadline = new Date(d);
    deadline.setDate(deadline.getDate() - 1);
    deadline.setHours(12, 0, 0, 0);
    return { deadline, auctionDate: d };
}

export const OfferDeadlineBadge = ({ auctionDateIso, auctionDate, testid = "offer-deadline" }) => {
    const [now, setNow] = useState(() => Date.now());
    useEffect(() => {
        const t = setInterval(() => setNow(Date.now()), 60000);
        return () => clearInterval(t);
    }, []);

    const info = computeOfferDeadline(auctionDateIso, auctionDate);
    if (!info) return null;
    const { deadline, auctionDate: d } = info;
    const auctionEnd = new Date(d);
    auctionEnd.setHours(23, 59, 59, 999);
    const ms = deadline.getTime() - now;
    const fmtDate = deadline.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit" });

    let cls, text, pulse = false;
    if (now > auctionEnd.getTime()) {
        cls = "bg-gray-100 text-gray-500 border-gray-200";
        text = "Asta conclusa";
    } else if (ms <= 0) {
        cls = "bg-red-50 text-red-700 border-red-300";
        text = "Termine offerte probabilmente scaduto — verifica l'avviso";
    } else if (ms <= 48 * 3600 * 1000) {
        const h = Math.max(1, Math.floor(ms / 3600000));
        cls = "bg-red-50 text-red-700 border-red-300";
        text = `Offerte entro ~${h}h (${fmtDate} ore 12:00)`;
        pulse = true;
    } else if (ms <= 7 * 24 * 3600 * 1000) {
        const days = Math.ceil(ms / 86400000);
        cls = "bg-amber-50 text-amber-700 border-amber-300";
        text = `Offerte entro ${days} giorni (${fmtDate})`;
    } else {
        cls = "bg-blue-50 text-blue-700 border-blue-200";
        text = `Offerte entro il ${fmtDate}, ore 12:00`;
    }

    return (
        <span
            data-testid={testid}
            title="Termine stimato di presentazione delle offerte: tipicamente entro le 12:00 del giorno precedente l'asta. Verifica sempre l'avviso di vendita."
            className={`inline-flex items-center gap-1 border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${cls}`}
        >
            <Timer size={11} weight="bold" className={pulse ? "animate-pulse" : ""} />
            {text}
        </span>
    );
};

export default OfferDeadlineBadge;
